import React from 'react';

type Props = {
    children?: React.ReactNode,
    title: string,
    detail: string,
    list: Array<any> | undefined | null,
};

export default class EmptyView extends React.Component<Props> {
    static defaultProps = {
        title: 'Keine Daten gefunden',
        detail: '',
    };

    render() {
        if (this.props.list && this.props.list.length > 0) return null;

        return (
            <div className="application-empty">
                <h3 className="application-empty-title">{this.props.title}</h3>
                <div className="application-empty-detail">{this.props.detail}</div>
                {this.props.children}
            </div>
        );
    }
}
